// Einsatzgebiet.js – Seite /einsatzgebiet: Orte und Region, die Forst & Flur bedient (Liste orte).
import "./Home.css";
import "./custom.css";
import usePageMeta from "../../usePageMeta";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import betrieb from "../../data/betrieb";

// Die Orte stehen in src/data/betrieb.js (einsatzorte, dort auch areaServed der Strukturdaten); Fließtext in src/data/faq.js.
function Einsatzgebiet() {
  usePageMeta({
    path: "/einsatzgebiet",
    title: "Einsatzgebiet: Kiel, Plön & Schleswig-Holstein | Forst & Flur",
    description:
      "Forst & Flur ist von Probsteierhagen aus im Einsatz: Kiel, Schönberg, Plön, Preetz, Lütjenburg, Lübeck, Neumünster, Eckernförde und Rendsburg.",
  });

  return (
    <div>
      <div className="ff-page-hero">
        <div className="ff-page-hero__content">
          <span className="ff-eyebrow">Forst &amp; Flur</span>
          <h1 className="ff-page-hero__title">Einsatzgebiet</h1>
          <p className="ff-page-hero__sub">Von Probsteierhagen aus in ganz Schleswig-Holstein</p>
        </div>
      </div>

      <div className="custom-dark-green text-white">
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={10}>
              <p className="fs-5 text-shadow">
                Mein Betrieb sitzt in Probsteierhagen im Kreis Plön. Von hier aus bin ich für Baumfällung,
                Baumpflege, Holzrücken und Landschaftspflege in ganz Schleswig-Holstein unterwegs.
                Regelmäßig arbeite ich in und um:
              </p>

              <ul className="ff-checklist my-4" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(14rem, 1fr))" }}>
                {betrieb.einsatzorte.map((o) => (
                  <li key={o}>
                    <strong>{o}</strong>
                  </li>
                ))}
              </ul>

              <p className="fs-5 text-shadow">
                Ihr Ort steht nicht dabei? Fragen Sie einfach an. Je nach Auftrag und Entfernung finden wir
                eine Lösung. Die erste Besichtigung ist die Grundlage für ein faires Angebot.
              </p>

              <div className="mt-4 d-flex flex-wrap gap-3">
                <Link to="/kontakt" className="btn-ff-primary" onClick={() => window.scrollTo(0, 0)}>
                  Jetzt anfragen
                </Link>
                <Link to="/referenzen" className="btn-ff-outline" onClick={() => window.scrollTo(0, 0)}>
                  Referenzen ansehen
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Einsatzgebiet;
